/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

 import { NgModule } from '@angular/core';
 import {MatToolbarModule} from '@angular/material/toolbar';
 import {MatIconModule} from '@angular/material/icon';
 import {MatButtonModule} from '@angular/material/button';
 import {MatTabsModule} from '@angular/material/tabs';
 import {MatInputModule} from '@angular/material/input';
 import {MatChipsModule} from '@angular/material/chips';
 import {MatSelectModule} from '@angular/material/select';
 import { MatFormFieldModule } from '@angular/material/form-field';
 import {MatMenuModule} from '@angular/material/menu';
 import {MatListModule} from '@angular/material/list';
 import {MatDialogModule} from '@angular/material/dialog';
 import {MatSnackBarModule} from '@angular/material/snack-bar';
 import {MatStepperModule} from '@angular/material/stepper';
 import {MatBadgeModule} from '@angular/material/badge';
 import {MatSortModule} from '@angular/material/sort';
 import {MatPaginatorModule} from '@angular/material/paginator';
 import {MatTableModule} from '@angular/material/table';
 import {MatDatepickerModule} from '@angular/material/datepicker';
 import { MatNativeDateModule } from '@angular/material/core';
 import { MatCheckboxModule } from '@angular/material/checkbox';
 import { MatSidenavModule } from '@angular/material/sidenav'; 
 import {MatTreeModule} from '@angular/material/tree';
 import {MatTooltipModule} from '@angular/material/tooltip';
 import {MatRadioModule} from '@angular/material/radio';
 import {MatRippleModule} from '@angular/material/core';
 import { MatCardModule } from '@angular/material/card';
 
 /**
  * NgModule that includes all Material modules that are required to serve the demo-app.
  */
 @NgModule({
     exports: [
         MatToolbarModule,
         MatIconModule,
         MatButtonModule,
         MatTabsModule,
         MatInputModule,
         MatChipsModule,
         MatSelectModule,
         MatFormFieldModule,
         MatMenuModule,
         MatListModule,
         MatDialogModule,
         MatSnackBarModule,
         MatStepperModule,
         MatBadgeModule,
         MatSortModule,
         MatPaginatorModule,
         MatTableModule,
         MatDatepickerModule,
         MatCardModule,
         MatNativeDateModule,
         MatCheckboxModule,
         MatSidenavModule,
         MatTreeModule,
         MatTooltipModule,
         MatRadioModule,
         MatRippleModule
     ]
 })
 export class MaterialModule { }